
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"43","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"x":"-6.4%","y":"-7%","width":"112.8%","height":"108.2%","filterUnits":"objectBoundingBox","id":"b"}},[_c('feGaussianBlur',{attrs:{"stdDeviation":".5","in":"SourceAlpha","result":"shadowBlurInner1"}}),_c('feOffset',{attrs:{"dy":"3","in":"shadowBlurInner1","result":"shadowOffsetInner1"}}),_c('feComposite',{attrs:{"in":"shadowOffsetInner1","in2":"SourceAlpha","operator":"arithmetic","k2":"-1","k3":"1","result":"shadowInnerInner1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.873471467 0 0 0 0 0.873471467 0 0 0 0 0.873471467 0 0 0 1 0","in":"shadowInnerInner1"}})]),_c('path',{attrs:{"d":"M5.4 0h36.2A5.4 5.4 0 0147 5.4v19.749a5.4 5.4 0 01-5.4 5.4H24.345l-9.607 9.442a1.8 1.8 0 01-3.061-1.284v-8.158H5.4a5.4 5.4 0 01-5.4-5.4V5.4A5.4 5.4 0 015.4 0z","id":"a"}})]),_c('g',{attrs:{"transform":"translate(1 1)","fill":"none","fill-rule":"evenodd"}},[_c('use',{attrs:{"fill":"#FFF","xlink:href":"#a"}}),_c('use',{attrs:{"fill":"#000","filter":"url(#b)","xlink:href":"#a"}}),_c('path',{attrs:{"stroke":"#CCC","d":"M5.4.5A4.9 4.9 0 00.5 5.4v19.749a4.9 4.9 0 004.9 4.9h6.777v8.658a1.3 1.3 0 002.21.927l9.753-9.585H41.6a4.9 4.9 0 004.9-4.9V5.4A4.9 4.9 0 0041.6.5H5.4z","stroke-linejoin":"square"}}),_c('path',{attrs:{"stroke":"#FFF","d":"M24.55 31.049l-9.461 9.298a2.3 2.3 0 01-3.912-1.64v-7.658H5.4a5.9 5.9 0 01-5.9-5.9V5.4A5.9 5.9 0 015.4-.5h36.2a5.9 5.9 0 015.9 5.9v19.749a5.9 5.9 0 01-5.9 5.9H24.55z"}})])])
          )
        }
      }
    